module.exports = __webpack_public_path__ + "img/L3.b59b83e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cooperation/banner/L3.png
// module id = NZ/Z
// module chunks = 0